module.exports = __webpack_public_path__ + "img/alex.a8d8ebea.svg";